export default __webpack_public_path__ + "static/media/acter1.0932c602.png";